const BASE_URL = process.env.REACT_APP_BASE_URL

export const getToken = (): string => {
    const token = localStorage.getItem("access_token");
    if (!token) {
        throw new Error("Missing access token");
    }
    return token
}

type ResponseTypes = {
    message: string;
    httpStatus: string;
    data?: any;
    errorCode?: number;
    errorMessage?: number;
    access_token?: string
}

// export type APIResponseModuleDataType = {
//     id: string;
//     name: string;
//     description: string;
// }

// export const APIGetModuleMenuDetails = async (): Promise<{ status: boolean; data: APIResponseModuleDataType[], message: string }> => {
//     const URL: string = `${BASE_URL}/tutorial/api/v1/getModules`
//     const HEAD: RequestInit = {
//         method: 'GET',
//         headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${getToken()}`
//         }
//     }

//     try 
//     {
//         const response = await fetch(URL, HEAD)

//         if (response.ok)
//         {
//             const responseData = await response.json() as ResponseTypes
//             return {status: true, data: responseData.data as APIResponseModuleDataType[], message: 'success'}
//         }
//         else 
//         {
//             return {status: false, data: [], message: 'failed getting response from the server'}
//         }
//     }
//     catch (error)
//     {
//         console.error("error getting tutorial data to side menu with error", error)
//         return {status: false, data: [], message: 'error getting tutorial data to side menu'}
//     }
// }

export type APIResponseModuleDataType = {
    moduleId: string;
    moduleName: string;
}

export const APIGetModuleMenuDetails = async (): Promise<{ status: boolean; data: APIResponseModuleDataType[], message: string }> => {
    const URL: string = `${BASE_URL}/tutorial/api/v2/getModules`
    const HEAD: RequestInit = {
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getToken()}`
        }
    }

    try 
    {
        const response = await fetch(URL, HEAD)

        if (response.ok)
        {
            const responseData = await response.json() as ResponseTypes
            return {status: true, data: responseData.data as APIResponseModuleDataType[], message: 'success'}
        }
        else 
        {
            return {status: false, data: [], message: 'failed getting response from the server'}
        }
    }
    catch (error)
    {
        console.error("error getting tutorial data to side menu with error", error)
        return {status: false, data: [], message: 'error getting tutorial data to side menu'}
    }
}